import { put, select } from 'redux-saga/effects';
import {
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAILURE,
} from '../actions/actionTypes';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

import { convertObjectToQueryParams } from 'src/utils/util';
import { getconsignmentAddProductSearchDataService } from 'src/pages/consignmentAdd/services';

export default function* searchProducts(action) {
    //let url = getconsignmentAddProductSearch ;
    const queryParams = yield select(
        (state) => state.consignmentAddProductsSearchReducer.queryParams
    );

    const token = queryParams.cancelSearchToken;
    delete queryParams.cancelSearchToken;
    //if (queryParams) url = ;

    try {
        /*const result = yield axios
            .get(url, { cancelToken: token })
            .then((response) => response.data);
        console.log(result);*/

        const result = yield getconsignmentAddProductSearchDataService(
            convertObjectToQueryParams(queryParams),
            token
        );

        yield put({
            type: GET_PRODUCTS_SUCCESS,
            products: action.payload.isBundle
                ? result.productsList
                    ? result.productsList.filter(
                          (product) =>
                              product.salesOrg != 'S030' &&
                              product.materialType != 'ZKMT'
                      )
                    : []
                : result.productsList || [],
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            totalRecordsCount: result.productsTotalCount,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/products/productList`,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRODUCTS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
